var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberPlanProPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    rx: 8,
    fill: "url(#paint0_linear_16939_108982)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16939_108982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 76
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 120,
    height: 75,
    rx: 8,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16939_108982)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.5,
    cy: 80.498,
    rx: 70.5,
    ry: 49.5,
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16939_108982",
    x1: 108.706,
    y1: 77.4324,
    x2: 53.9765,
    y2: 4.71028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA7C08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberPlanProPlus);
export default __webpack_public_path__ + "static/media/subscriber-plan-pro-plus.3c25821f63759387348118c9512808ee.svg";
export { ForwardRef as ReactComponent };